import _isEqual from 'lodash/isEqual';
import { useEffect, useState } from 'react';

/**
 * - used to update state with defaultValue / prop on page reload
 */
export function useStateWithDep<T>(defaultValue: T) {
  const [value, setValue] = useState<T>(defaultValue);

  useEffect(() => {
    if (defaultValue && !_isEqual(defaultValue, value)) {
      setValue(defaultValue);
    }
  }, [defaultValue]);
  return [value, setValue] as const;
}
